import { useState } from "react";
import { Box, ButtonBase, Chip, Grid, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { ReleaseUpdate } from "../../types/ReleaseUpdate";
import { MediaObject } from "../../types/MediaObject";
import DisplayMediaObjects from "../MediaObject/DisplayMediaObjects";
import releaseUpdateStyles from "./releaseUpdatesStyles";

type ReleaseUpdateContentProps = {
  message: ReleaseUpdate;
  publishedAt: string | null;
  mediaObjects: MediaObject[];
};

export default function ReleaseUpdateContent({
  message,
  publishedAt,
  mediaObjects,
}: ReleaseUpdateContentProps) {
  const [mediaObjectToDisplay, setMediaObjectToDisplay] = useState<MediaObject | null>(null);
  const messageMediaObjects = message.mediaObjectIds
    .map((mediaObjectId) => mediaObjects.find((mediaObject) => mediaObject.id === mediaObjectId))
    .filter((mediaObject): mediaObject is MediaObject => mediaObject !== null && mediaObject !== undefined);
  const firstMediaObject = messageMediaObjects[0] ?? null;

  return (
    <>
      <Grid container spacing={2} sx={releaseUpdateStyles.metaRow}>
        <Grid>
          <Grid container spacing={1}>
            {message.productArea && (
              <Grid>
                <Chip label={message.productArea} color="primary" variant="filled" />
              </Grid>
            )}
            {message.topic && (
              <Grid>
                <Chip label={message.topic} color="primary" variant="filled" />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid>
          <Typography color="textSecondary">
            {publishedAt ? dayjs(publishedAt).format("DD.MM.YYYY") : "Vorschau"}
          </Typography>
        </Grid>
      </Grid>
      <Stack direction={"row"}>
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h2" sx={{ marginBottom: "1rem" }}>
            {message.headline}
          </Typography>
          <Grid size={firstMediaObject ? { xs: 12, md: 7 } : 12}>
            <Box dangerouslySetInnerHTML={{ __html: message.content }} />
          </Grid>
        </Box>
        <Box sx={{ flexShrink: 0 }}>
          {firstMediaObject && (
            <Grid size={{ xs: 12, md: 5 }}>
              <ButtonBase onClick={() => setMediaObjectToDisplay(firstMediaObject)} sx={releaseUpdateStyles.imageButton}>
                <Box component="img" src={firstMediaObject.displayUrl} sx={releaseUpdateStyles.mainImage} />
              </ButtonBase>
              {messageMediaObjects.length > 1 && (
                <Grid container spacing={1} sx={releaseUpdateStyles.thumbnailRow}>
                  {messageMediaObjects.map((mediaObject) => (
                    <Grid key={mediaObject.id}>
                      <ButtonBase
                        onClick={() => setMediaObjectToDisplay(mediaObject)}
                        sx={releaseUpdateStyles.thumbnailButton}
                      >
                        <Box component="img" src={mediaObject.displayUrl} sx={releaseUpdateStyles.thumbnailImage} />
                      </ButtonBase>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>
          )}
        </Box>
      </Stack>
      <DisplayMediaObjects
        mediaObjects={messageMediaObjects}
        mediaObjectToDisplay={mediaObjectToDisplay}
        setMediaObjectToDisplay={setMediaObjectToDisplay}
      />
    </>
  );
}
